import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './filtersSlice';
import userReducer from './userSlice';
import flowReducer from "./flowSlice";
import scoreReducer from "./score/scoreSlice";
import jobsReducer from "./jobsSlice";
import debugReducer from "./debugSlice";
import languageReducer from './languageSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist'

const persistedJobsReducer = persistReducer({
  key: "jobs",
  storage,
}, jobsReducer);

const persistedUserReducer = persistReducer({
  key: "user",
  storage,
}, userReducer);

const persistedLanguageReducer = persistReducer({
  key: "language",
  storage,
}, languageReducer);

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    user: persistedUserReducer,
    flow: flowReducer,
    score: scoreReducer,
    jobs: persistedJobsReducer,
    debug: debugReducer,
    language: persistedLanguageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // serializableCheck: {
      //   ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      // },
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;